/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `am ${i.date}`
};

const en_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `on ${i.date}`
};

const es_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `el ${i.date}`
};

const fr_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Mis à jour le ${i.date}`
};

const it_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `il ${i.date}`
};

const nl_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `op ${i.date}`
};

const pt_poi_card__updated = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `em ${i.date}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__updated(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__updated", locale)
	if (locale === "de") return de_poi_card__updated(inputs)
	if (locale === "en") return en_poi_card__updated(inputs)
	if (locale === "es") return es_poi_card__updated(inputs)
	if (locale === "fr") return fr_poi_card__updated(inputs)
	if (locale === "it") return it_poi_card__updated(inputs)
	if (locale === "nl") return nl_poi_card__updated(inputs)
	return pt_poi_card__updated(inputs)
};